export default [{
  label: 'Razão social', field: 'nome', editable: true, evento: null,
},
{ label: 'Procuração', field: 'porProcuracao' },
{ label: 'Status', field: 'status' },
{ label: 'Vencimento', field: 'vencimento', type: 'custom' }] // type: cutom
